import React from 'react'

export const ModalPropsContext = React.createContext(undefined)
export const ModalHandlersContext = React.createContext(undefined)
